//
import GUserModel from '@/models/General/GUser'

//
export default [
  {
    name: 'id_vendedor',
    type: 'autocomplete-model',
    props: {
      itemText: 'full_name',
      itemValue: 'id',
      label: 'Vendedor',
      model: GUserModel,
      noObject: true,
      paramFilter: {
        is_ground_seller: true,
      }
    },
  },
  {
    name: 'fecha_emision_min',
    type: 'date-field',
    props: {
      label: 'Desde',
    },
  },
  {
    name: 'fecha_emision_max',
    type: 'date-field',
    props: {
      label: 'Hasta',
    },
  },
]
